export default __webpack_public_path__ + "static/ccr-csr-logo-72520edec58066d5d6d57f8193413371.png";